import { useNavigate } from 'react-router-dom';

import { TagComponent } from 'components/tag/TagComponent';
import {
  Avatar,
  Row,
  Spacing,
  Typography,
  getFirstLetterInName,
  neutral,
  neutralTrans,
} from 'enable-ui';

import { Container, UserAction, UserActionItem } from '../styles/user-profile';

import { ReactComponent as LogoutIcon } from 'assets/icons/logout_v2.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/view-profile.svg';

import { getUserColor } from 'helpers';

import { COLOR, COLOR_CONFIG } from 'constants/color';
import { PATH } from 'constants/path';

import { APP_VERSION } from '../../../constants/environment';
import { onLogout } from '../core/constrollers/master-layout';
import { useUserProfileController } from '../core/constrollers/user-profile';

export const PopoverUserProfile: React.FC<{
  setVisible: (value: boolean) => void;
}> = ({ setVisible }) => {
  const navigate = useNavigate();
  const { userProfile } = useUserProfileController();

  const avatarSrc = userProfile?.physicalProfile?.avatar || '';

  const isSuperAdmin = userProfile?.isSuperAdmin;

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  const goToProfile = () => {
    setVisible(false);

    return navigate(`${PATH.PROFILE}/${PATH.USERNAME}`);
  };

  return (
    <Container>
      <Spacing spacing="md">
        <Spacing spacing="sm" type="margin" placement="bottom">
          <Row>
            <TagComponent
              color={COLOR.purpel['purpel-6']}
              text={userProfile?.role?.name}
              customStyle={{ fontWeight: 500, fontSize: 12 }}
            />

            {isSuperAdmin ? (
              <TagComponent
                color={COLOR_CONFIG.red}
                text="Super Admin"
                customStyle={{ fontWeight: 500, fontSize: 12, marginLeft: 12 }}
              />
            ) : null}
          </Row>
        </Spacing>
        <Row align="center">
          <Avatar
            items={{
              label: getFirstLetterInName(userProfile?.name, true),
              src: avatarSrc,
            }}
            containerStyle={{
              width: 'auto',
            }}
            size="large"
            config={{
              bg: userProfile?.avatar ? 'transparent' : getUserColor(userProfile?.name),
              color: neutral['neutral-1'],
              border: ` 1px solid ${neutralTrans['neutralTrans-15']}`,
            }}
          />
          <Spacing
            spacing="sm"
            type="margin"
            placement="left"
            style={{ width: 'calc(100% - 36px)' }}
          >
            <Row direction="column">
              <Typography
                weight={600}
                variant="h5"
                style={{
                  width: '98%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textAlign: 'start',
                }}
              >
                {userProfile?.name}
              </Typography>
              <Typography
                weight={400}
                style={{
                  width: '98%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textAlign: 'start',
                }}
                color={neutral['neutral-7']}
              >
                {userProfile?.email}
              </Typography>
            </Row>
          </Spacing>
        </Row>
        {userProfile?.institution ? (
          <Spacing spacing="md" type="margin" placement="top">
            <Typography variant="body-2" weight={400} color={neutral['neutral-7']}>
              {`ID: ${userProfile.institution.code}`}
            </Typography>
          </Spacing>
        ) : null}
      </Spacing>
      <UserAction direction="column">
        <UserActionItem align="center" onClick={goToProfile}>
          <Spacing
            spacing="xxxs"
            style={{
              height: 24,
            }}
          >
            <ProfileIcon />
          </Spacing>
          <Typography
            weight={400}
            color={COLOR.surfaceNeutralBold['neutral-11']}
            style={{
              marginLeft: 8,
              fontSize: 18,
              lineHeight: '26px',
            }}
          >
            My profile
          </Typography>
        </UserActionItem>
        <UserActionItem align="center" onClick={handleLogout}>
          <Spacing
            spacing="xxxs"
            style={{
              height: 24,
            }}
          >
            <LogoutIcon />
          </Spacing>
          <Typography
            weight={400}
            color={COLOR.surfaceNeutralBold['neutral-11']}
            style={{
              marginLeft: 8,
              fontSize: 18,
              lineHeight: '26px',
            }}
          >
            Log out
          </Typography>
        </UserActionItem>
      </UserAction>
      <Spacing spacing="xs" type="padding">
        <Typography
          weight={400}
          color={neutral['neutral-7']}
          style={{
            marginLeft: 8,
            fontSize: 12,
          }}
        >
          {APP_VERSION}
        </Typography>
      </Spacing>
    </Container>
  );
};
